﻿(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-complaint]');
    const fieldset = form.querySelector('fieldset');
    const feedback = root.querySelector('[data-feedback]');
    const service = root.querySelector('[data-service-message]');
    const path = (root.dataset.apiPath || '').replace(/\/$/, '');
    let submitted = false;
    async function api(route, body) {
      const multipart = body instanceof FormData;
      const response = await fetch(path + route, {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: multipart ? {} : { 'Content-Type': 'application/json' },
        body: multipart ? body : JSON.stringify(body), signal: AbortSignal.timeout(120000)
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || !data) throw new Error(route === '/orders/lookup' ? (data?.error || 'Unable to fetch order details. Please try again or enter the details manually.') : 'Unable to confirm submission. Contact the store before submitting again.');
      return data;
    }
    function money(value) {
      if (!value || value.amount == null || !Number.isFinite(Number(value.amount)) || !/^[A-Z]{3}$/.test(value.currencyCode)) return '';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: value.currencyCode }).format(Number(value.amount));
      } catch { return value.currencyCode + ' ' + value.amount; }
    }
    const orderLookup = root.querySelector('[data-order-lookup]');
    if (orderLookup) {
      const summary = root.querySelector('[data-order-summary]');
      const pricing = root.querySelector('[data-product-pricing]');
      function clearPricing() {
        if (!pricing) return;
        pricing.hidden = true;
        pricing.querySelector('[data-product-price]').value = '';
        pricing.querySelector('[data-product-amount]').value = '';
      }
      let version = 0;
      let lookupTimer;
      const orderInput = orderLookup.elements.order_number;
      function scheduleLookup() {
        clearTimeout(lookupTimer);
        version++;
        summary.hidden = true;
        clearPricing();
        feedback.textContent = '';
        const number = orderInput.value.trim();
        if (submitted || !/^#?[A-Za-z0-9_./ -]{1,79}$/.test(number) || !/\d/.test(number)) return;
        lookupTimer = setTimeout(() => {
          if (!submitted && !orderInput.disabled && !orderLookup.querySelector('fieldset').disabled) orderLookup.requestSubmit();
        }, 800);
      }
      orderLookup.addEventListener('input', scheduleLookup);
      orderLookup.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearTimeout(lookupTimer);
        if (submitted) return;
        const current = ++version;
        const values = Object.fromEntries(new FormData(orderLookup));
        const lookupFields = orderLookup.querySelector('fieldset');
        orderLookup.setAttribute('aria-busy', 'true');
        summary.hidden = true;
        clearPricing();
        feedback.textContent = 'Fetching your order...';
        try {
          const { order } = await api('/orders/lookup', values);
          if (current !== version || submitted) return;
          if (!order || !Array.isArray(order.items) || !order.items.length) throw new Error('Order details are incomplete. Enter your details manually.');
          if (typeof order.name === 'string') form.elements.name.value = order.name;
          if (typeof order.email === 'string') form.elements.email.value = order.email;
          form.elements.phone.value = order.phone || '';
          form.elements.order_number.value = order.order_number;
          const select = document.createElement('select');
          select.name = 'product';
          select.required = true;
          select.add(new Option('Choose the affected product', ''));
          order.items.forEach((item) => {
            const price = money(item.unit_price);
            const amount = money(item.amount);
            select.add(new Option(item.title + ' (quantity: ' + item.quantity + ')' +
              (price ? ' - unit price: ' + price : '') + (amount ? ' - amount after discounts: ' + amount : ''), item.title));
          });
          if (order.items.length === 1) select.selectedIndex = 1;
          function showPricing() {
            const item = order.items[select.selectedIndex - 1];
            if (!pricing || !item) { clearPricing(); return; }
            pricing.querySelector('[data-product-price]').value = money(item.unit_price) || 'Unavailable';
            pricing.querySelector('[data-product-amount]').value = money(item.amount) || 'Unavailable';
            pricing.hidden = false;
          }
          select.addEventListener('change', showPricing);
          form.elements.product.replaceWith(select);
          showPricing();
          summary.textContent = 'Order ' + order.order_number + ' - placed ' + new Date(order.created_at).toLocaleDateString() + (money(order.total) ? ' - order total: ' + money(order.total) : '');
          summary.hidden = false;
          feedback.textContent = 'Order details filled. Select the affected product and describe the problem below.' + (!order.email ? ' This order has no email saved; please enter your contact email.' : '');
        } catch (error) {
          if (current === version && !submitted) feedback.textContent = error.message;
        } finally {
          lookupFields.disabled = submitted;
          if (current === version) orderLookup.removeAttribute('aria-busy');
        }
      });
      form.elements.order_number.addEventListener('input', () => {
        version++;
        summary.hidden = true;
        clearPricing();
        orderInput.value = form.elements.order_number.value;
        scheduleLookup();
        const product = form.elements.product;
        if (product.tagName === 'SELECT') {
          const input = document.createElement('input');
          input.name = 'product'; input.maxLength = 200; input.required = true;
          product.replaceWith(input);
        }
      });
    }
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitted) return;
      const values = new FormData(form);
      const files = values.getAll('files').filter((file) => file.size);
      if (!files.length || files.length > 5 || files.some((file) => file.size > 10 * 1024 * 1024 || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) || files.reduce((sum, file) => sum + file.size, 0) > 25 * 1024 * 1024) {
        feedback.textContent = 'Attach 1–5 JPG, PNG or WebP photos, up to 10 MB each and 25 MB total.';
        feedback.focus();
        return;
      }
      const videos = values.getAll('unboxing_video').filter((file) => file.size);
      if (videos.length > 1 || videos.some((file) => file.size > 50 * 1024 * 1024 || !['video/mp4', 'video/quicktime', 'video/webm'].includes(file.type))) {
        feedback.textContent = 'Choose one MP4, MOV or WebM unboxing video, up to 50 MB.';
        feedback.focus();
        return;
      }
      values.set('request_id', crypto.randomUUID());
      submitted = true;
      if (orderLookup) orderLookup.querySelector('fieldset').disabled = true;
      fieldset.disabled = true;
      form.setAttribute('aria-busy', 'true');
      feedback.textContent = 'Submitting your complaint and attachments…';
      try {
        const result = await api('/tickets', values);
        if (result.status !== 'created') throw new Error('Your request was sent, but ticket creation could not be confirmed. Contact the store before submitting again.');
        form.reset();
        feedback.textContent = 'Your complaint and attachments were submitted successfully.' + (result.ticket_id ? ' Ticket number: ' + result.ticket_id + '.' : '') + ' Our team will review your request.';
      } catch (error) {
        feedback.textContent = error.name === 'TimeoutError' ? 'Submission timed out. A ticket may have been created. Contact the store before submitting again.' : error.message;
      } finally {
        form.removeAttribute('aria-busy');
        feedback.focus();
      }
    });
    async function connect() {
      if (!/^\/apps\/[a-zA-Z0-9_/-]+$/.test(path)) {
        service.textContent = 'Online complaints are not available yet. Please contact the store for assistance.';
        return;
      }
      try {
        const health = await api('/health', {});
        if (health.ready !== true) throw new Error();
        service.textContent = '';
        fieldset.disabled = false;
        if (orderLookup) orderLookup.querySelector('fieldset').disabled = false;
      } catch {
        service.textContent = 'The support service is unavailable. Please contact the store or try again later.';
      }
    }
    connect();
  }
  const scan = () => document.querySelectorAll('[data-return-exchange]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
